<div class="px-4 text-sm">
  <span class="font-normal">{{leavingInText}}</span>
  <ng-icon [ngClass]="{'text-[#008667]': departureData.nextStopsTimes[0].isRealTime , 'text-[#000000]' : !departureData.nextStopsTimes[0].isRealTime}" name="rss-feed" class="text-xs" role="img" [attr.aria-label]="leavingInText"></ng-icon>&nbsp;
  @for (stopTime of departureData.nextStopsTimes; track stopTime; let isLast = $last) {
    <span>
        <span [ngClass]="{
            'text-[#008667]': stopTime.isRealTime
          }">{{getTimeDiffs(stopTime)}}
      </span>
      @if (!isLast) {
        <span>,</span>
      }
    </span>
  }
  <span class="font-normal">{{leavingStationDataText}}</span>
</div>
